import React, { useEffect, useMemo, useState } from "react";
import {
	// makeStyles,
	// Dialog,
	Box,
	Typography,
	Button,
	CircularProgress,
	useTheme,
} from "@material-ui/core";
import OtpInput from "react-otp-input";
// import { PopUp } from '../../BasePopUp';
import authService from "src/services/authService";
import { useLayout, useTimeleft } from "src/utils/customHook";
import BaseDrawer from "src/components/PopUp/BaseDrawer";
import { PopUp } from "src/components/PopUp/BasePopUp";
import { defaultModalProps } from "modal-tpyes";
import { banOTPErrorType } from "src/types/error-types";
import { ERROR_CODE } from "src/context/constants/errorCode";
// import BaseDrawer from '../../BaseDrawer';

export interface OTPConfirmModalProps {
	onSuccess?: () => void;
	onFail?: (error: any) => void;
	onClose?: () => void;
	onBack?: () => void;
	title?: string;
	message?: string;
	sendAgain?: () => Promise<any> | any;
}

var timer: any = undefined;
const OTP_INTERVAL = 30;

const OTPConfirmModal: React.FC<defaultModalProps> = ({
	handleClose,
	open,
	handleBack,
	props: modalProps,
}) => {
	const theme = useTheme();

	const { isSmall } = useLayout();
	const [props, setProps] = useState<OTPConfirmModalProps>();
	const [loading, setLoading] = useState(false);
	const [otp, setOtp] = useState("");
	const [otpError, setOtpError] = useState(false);
	const { timeLeft, restartCount } = useTimeleft(OTP_INTERVAL);
	// const [otpTimeLeft,setOtpTimeLeft] = useState(0);

	useEffect(() => {
		if (modalProps) {
			setProps(modalProps);
		}
	}, [modalProps]);

	const stopTimer = () => {
		clearInterval(timer);
	};


	const timeLeftMessage = useMemo(() => {
		const minutes = Math.floor(timeLeft / 60);
		const seconds = timeLeft - 60 * minutes;
		if (minutes > 0) return `${minutes} นาที ${seconds} วินาที`;
		return `${seconds} วินาที`;
	}, [timeLeft]);

	// const isBan = useMemo(()=>{
	//   if (timeLeft > 0) return true
	//   return false
	// },[timeLeft])

	const banErrorCallback = (err: banOTPErrorType) => {
		if (err.code === ERROR_CODE.OTP_BAN) {
			if (err.second) restartCount(err.second);
		}
	};

	// const startTimer = () => {
	//   timer = setInterval(()=>{
	//     setOtpTimeLeft((prev)=>prev-1)
	//   },1000)
	// }

	// useEffect(()=>{
	//   if (otpTimeLeft <= 0) stopTimer()
	// },[otpTimeLeft])

	useEffect(() => {
		if (open) {
			setOtp("");
			setOtpError(false);
			restartCount(OTP_INTERVAL);
			setLoading(false);
		}
		return () => {
			stopTimer();
		};
		// eslint-disable-next-line
	}, [open]);

	const handleOTPChange = (otp: string) => {
		setOtp(otp);
		setOtpError(false);
	};

	const wrapperHandleClsoe = () => {
		handleClose();
		if (props?.onClose) props.onClose();
	};

	const wrapperHandleBack = () => {
		handleClose();
		if (props?.onBack) props.onBack();
	};

	const onClickSendAgain = async () => {
		try {
			setLoading(true);
			restartCount(OTP_INTERVAL);
			// if (onSuccess) await onSuccess()
			if (props?.sendAgain) await props?.sendAgain();
			setLoading(false);
		} catch (err) {
			banErrorCallback(err);
			setLoading(false);
		}
	};

	const verifyOTP = async () => {
		try {
			setOtpError(false);
			setLoading(true);
			await authService.verifyOTP(otp);
			setLoading(false);
			if (props?.onSuccess) await props.onSuccess();
			// onClose();
		} catch (err) {
			setOtpError(true);
			setLoading(false);
			if (props?.onFail) props?.onFail(err);
		}
	};

	useEffect(() => {
		if (otp.length === 4) verifyOTP();
		// eslint-disable-next-line
	}, [otp]);
	const renderDonotAccept = (
		<>
			<Typography variant="body2" color="textSecondary">
				ไม่ได้รับข้อความ OTP ?
			</Typography>
			<Button
				color="primary"
				disabled={timeLeft > 0}
				onClick={onClickSendAgain}
				style={{ paddingTop: 0, paddingBottom: 0 }}>
				ส่งอีกครั้ง
			</Button>
		</>
	);
	const renderEnterOTP = (
		<>
			<Typography variant="body2" color="textSecondary" align="center">
				ไม่ได้รับข้อความ OTP ? สามารถส่งอีกครั้งใน{" "}
				<span
					style={{
						color: theme.palette.primary.main,
					}}>{`${timeLeftMessage}`}</span>{" "}
			</Typography>
		</>
	);

	const RenderOtp = (
		<>
			<Box m={3} />
			<Typography variant="subtitle1" color="textSecondary" align="center">
				{props?.message}
			</Typography>
			<Box mt={4} />
			<Box mx="auto">
				<Box display="flex" alignItems="center" justifyContent="center">
					<OtpInput
						inputStyle={{
							color: theme.palette.text.primary,
							background: theme.palette.background.default,
							borderStyle: "solid solid solid solid",
							width: theme.spacing(7),
							height: theme.spacing(7),
							borderColor: theme.palette.text.secondary,
							borderRadius: "10px",
							borderWidth: "1px",
							margin: theme.spacing(1.25),
							fontSize: theme.spacing(2),
						}}
						errorStyle={{
							color: theme.palette.secondary.main,
							borderColor: theme.palette.secondary.main,
						}}
						focusStyle={{
							outline: "-webkit-focus-ring-color auto 0px",
							borderColor: theme.palette.primary.main,
						}}
						shouldAutoFocus={true}
						value={otp}
						onChange={handleOTPChange}
						numInputs={4}
						separator={<span />}
						isInputNum={true}
						hasErrored={otpError}
						isDisabled={loading}
					/>
				</Box>
				<Box mt={2} />
				{otpError && (
					<Typography variant="caption" color="secondary">
						รหัส OTP ไม่ถูกต้องโปรดลองใหม่
					</Typography>
				)}
				<Box display="flex" mt={2} alignItems="center" justifyContent="center">
					{timeLeft > 0 ? renderEnterOTP : renderDonotAccept}
				</Box>
				<Box mt={6} />
				{loading && <CircularProgress />}
			</Box>
		</>
	);

	if (isSmall)
		return (
			<BaseDrawer
				title={props?.title || "ยืนยันหมายเลขโทรศัพท์"}
				open={open || false}
				onClose={wrapperHandleClsoe}
				onBack={props?.onBack ? wrapperHandleBack : undefined}>
				{RenderOtp}
			</BaseDrawer>
		);

	return (
		<PopUp
			title={props?.title || "ยืนยันหมายเลขโทรศัพท์"}
			open={open || false}
			handleClose={wrapperHandleClsoe}
			onBack={props?.onBack ? wrapperHandleBack : undefined}>
			{RenderOtp}
		</PopUp>
	);
};

export default OTPConfirmModal;
